import PropTypes from 'prop-types';

export const SocketShape = PropTypes.shape({
    subscribe: PropTypes.func.isRequired,
});
